'use client'

import Link, { LinkProps } from 'next/link'
import { ForwardRefExoticComponent, RefAttributes } from 'react'

import { cn } from '@/lib/utils'

interface ButtonProps {
  size?: 'default' | 'xs' | 'sm' | 'md' | 'lg' | 'icon'
  className?: string
  href?: string
  primary?: boolean
  secondary?: boolean
  danger?: boolean
  red?: boolean
  purple?: boolean
  yellow?: boolean
  info?: boolean
  gray?: boolean
  oldPrimary?: boolean
  thegioiicPrimary?: boolean
  thegioiicGray?: boolean
  outline?: boolean
  disabled?: boolean
  full?: boolean
  rounded?: boolean
  children?: React.ReactNode
  onClick?: (e: any) => void
  passProps?: any
  type?: string
  scroll?: boolean
  target?: string
  comp?: string
  style?: any
  name?: string
}

export default function Button({
  size = 'default',
  className,
  href,
  type,
  primary = false,
  gray = false,
  danger = false,
  secondary = false,
  purple = false,
  yellow = false,
  outline = false,
  disabled = false,
  full = false,
  rounded = false,
  info = false,
  oldPrimary = false,
  red = false,
  thegioiicPrimary = false,
  thegioiicGray = false,
  children,
  scroll,
  target,
  comp,
  style,
  name,
  onClick,
  ...passProps
}: ButtonProps) {
  let Comp: ForwardRefExoticComponent<LinkProps & RefAttributes<HTMLAnchorElement>> | string = 'button'

  const props: any = {
    onClick,
    ...passProps,
  }

  if (disabled) {
    Object.keys(props).forEach((key) => {
      if (key.startsWith('on') && typeof [key] === 'function') {
        delete props[key]
      }
    })
  }

  if (href) {
    props.href = href
    Comp = Link
  } else if (type) {
    Comp = 'button'
  } else if (comp) {
    Comp = comp
  }

  return (
    <div
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
        }
      }}
      style={style}
    >
      <Comp
        target={target}
        {...props}
        scroll={scroll}
        name={name || 'randomName'}
        className={cn(
          'flex items-center justify-center outline-none no-underline w-auto font-normal transition-all duration-150 text-sm text-center border border-transparent',
          {
            'pointer-events-none cursor-not-allowed opacity-50': Boolean(disabled),
            'w-full': Boolean(full),

            // ============= css mới =============
            'border bg-white': Boolean(outline),
            // màu primary
            'btn-primary': Boolean(primary) && !Boolean(outline),
            'btn-primary-outline': Boolean(primary) && Boolean(outline),
            // màu đỏ
            'btn-red': Boolean(red) && !Boolean(outline),
            'btn-red-outline': Boolean(red) && Boolean(outline),
            // màu gray
            'btn-gray': Boolean(gray) && !Boolean(outline),
            'btn-gray-outline': Boolean(gray) && Boolean(outline),
            // màu secondary
            'btn-secondary': Boolean(secondary) && !Boolean(outline),
            'btn-secondary-outline': Boolean(secondary) && Boolean(outline),
            // màu tím
            'btn-purple': Boolean(purple) && !Boolean(outline),
            'btn-purple-outline': Boolean(purple) && Boolean(outline),
            // màu vàng
            'btn-yellow': Boolean(yellow) && !Boolean(outline),
            'btn-yellow-outline': Boolean(yellow) && Boolean(outline),
            // màu danger
            'btn-danger': Boolean(danger) && !Boolean(outline),
            'btn-danger-outline': Boolean(outline) && Boolean(danger),
            // màu nút thêm thegioiic cũ (btn add)
            'btn-info': Boolean(info) && !Boolean(outline),
            'btn-info-outline': Boolean(info) && Boolean(outline),
            // primary thegioiic cũ (btn add)
            'btn-old-primary': Boolean(oldPrimary) && !Boolean(outline),
            'btn-old-primary-outline': Boolean(oldPrimary) && Boolean(outline),
            // primary thegioiic mới (btn login)
            'btn-thegioiic-primary': Boolean(thegioiicPrimary) && !Boolean(outline),
            'btn-thegioiic-primary-outline': Boolean(thegioiicPrimary) && Boolean(outline),
            // gray thegioiic cũ
            'btn-thegioiic-gray': Boolean(thegioiicGray) && !Boolean(outline),
            'btn-thegioiic-gray-outline': Boolean(thegioiicGray) && Boolean(outline),
            rounded: Boolean(rounded),
            // ============= css mới =============

            // ' bg-primary !text-white hover:bg-opacity-90': Boolean(primary),
            // 'bg-[#eee] hover:text-primary': Boolean(secondary),
            // 'border border-primary !text-primary hover:bg-transparent bg-white lg:hover:bg-primary hover:!text-white': Boolean(outline),
            // rounded: Boolean(rounded),
            'h-10 px-4 py-2': Boolean(size === 'default'),
            'h-7 rounded lg:px-3 px-2 text-xs font-medium': Boolean(size === 'xs'),
            'h-8 rounded lg:px-3 px-2 text-xs font-medium': Boolean(size === 'sm'),
            'px-3 py-1.5 text-base': Boolean(size === 'md'),
            'h-11 rounded px-8 text-base': Boolean(size === 'lg'),
            'h-10 w-10': Boolean(size === 'icon'),
            // // màu danger
            // 'btn-danger': Boolean(danger) && !Boolean(outline),
            // 'btn-danger-outline': Boolean(outline) && Boolean(danger),
          },
          className,
        )}
      >
        <div className="flex items-center justify-center space-x-2">{children}</div>
      </Comp>
    </div>
  )
}
